export default "__VITE_ASSET__BtdPmiDn__"